<template>
    <div class="wrapper-form-block-anexos" :class="{'allow-markup-error': markupError}">
      <p><strong>Insira uma cópia do(s) documento(s)</strong></p>
      <br/>
      <p class="titulo-campo-preenchivel"><strong>Anexos</strong></p>
      <TrfButtonUpLoadAttachment
        tipLabel="Extensões permitidas: *.bmp, *.doc, *.dot, *.jpg, *.pdf, *.png, *.xls, *.odt, *.odf, *.rtf, *.txt, *.xml, *.html, *.gif, *.zip, *.rar, *.xlsx, *.docx, *.ppt, *.pptx, *.7z, *.jpeg, *.htm, *.csv, *.qrp, *.tdm, *.ofx, *.ofc."
        @uploadFile="doUploadAnexo"
        @onDrop="doUploadAnexo"
        ref="campoEmpresaAnexo"
        :inert="pPreview"
      >
      </TrfButtonUpLoadAttachment>
      <TrfListagemDeAnexosCadastro v-if="hasAnexos"
        :listagem-de-anexos="formData.anexos"
        :acoes="acoesDisponiveis"
        :preview="pPreview"
        @elegalize-remover-anexo="removerAnexo"
        @elegalize-visualizar-anexo="visualizarAnexo"
        @elegalize-download-anexo="downloadAnexo"
        ref="listagemAnexosEmpresa"
      >
      </TrfListagemDeAnexosCadastro>
      <p class="error-message" v-if="isInvalida">
        Campo obrigatório!
      </p>
    </div>
  </template>
  <script>
  import { defineAsyncComponent } from 'vue';
  export default {
    name: 'TrfBlocoAnexos',
    emits: ['update:form-data', 'set:validacao'],
    components: {
        TrfButtonUpLoadAttachment: defineAsyncComponent(() => import('../../ButtonUpload/TrfButtonUpLoadAttachment.vue')),
        TrfListagemDeAnexosCadastro: defineAsyncComponent(() => import('../../../views/Legalize/CadastroDeProcessos/Components/ListagemDeAnexosCadastro.vue'))
    },
    props: {
        pCampo: {
          type: Object,
          default: () => {}
        },
        pListaDeAnexos: {
            type: Array,
            default: () => []
        },
        pPreview: {
            type: Boolean,
            default: true
        },
        pIsDirty: {
          type: Boolean,
          default: false
        },
        pEmpresa: {
          type: Object,
          default: () => {}
        },
        pHasAnexos: {
          type: Boolean,
          default: false
        },
        required: {
          type: Boolean,
          defaut: false
        },
        pIsConferencia: {
          type: Boolean,
          default: false
        }
    },
    data() {
      return {
        loadings: {
          anexos: false,
        },
        formData: {
            anexos: Array.isArray(this.pEmpresa?.anexos)? [...this.pEmpresa.anexos] : this.pListaDeAnexos
        },
        isDirty: this.pIsDirty
      };
    },
    computed: {
        hasAnexos() {
            return this.pHasAnexos || (Array.isArray(this.formData.anexos) && this.formData.anexos.length > 0)
        },
        isInvalida() {
          if (!this.required) return false;
          return this.isDirty && !this.hasAnexos
        },
        markupError() {
          return !this.pPreview && this.isInvalida
        },
        acoesDisponiveis() {
          return this.pIsConferencia ? ['visualizar', 'download', 'excluir'] : ['excluir']
        }
    },
    watch: {
        pIsDirty: {
            immediate: true,
            handler(novo) {
                this.isDirty = novo
            }
        },
        isInvalida: {
            immediate: true,
            handler(novo) {
                if(this.required) {
                    this.$emit('set:validacao', !novo);
                }
            }
        }
    },
    methods: {
        async getFileUtils() {
          const { fileUtils } = await import('../../../util/file.utils.js');
          return fileUtils;
        },
        async doUploadAnexo(event) {
          if (this.pPreview) return;
          this.loadings.anexo = true;

          const files = event.target.files;
          const novosAnexos = [];

          const errors = [];

          const fileUtils = await this.getFileUtils();

          for await (const arquivo of Array.from(files)) {
            let base64 = await fileUtils.converterArquivoParaBase64(arquivo);
            base64 = base64.split(",")[1];

            const [, extensao] = fileUtils._splitNomeExtensao(arquivo.name);

            let anexo = {
              nome: arquivo.name,
              extensao,
              mime: arquivo.type,
              size: arquivo.size,
              bytes: base64,
            };

            if(anexo.size > fileUtils._converteMbParabyte(fileUtils.ANEXO_SIZE_LIMIT)) {
              errors.push(`Arquivo ${anexo.nome} excede o limite máximo permitido de ${fileUtils.ANEXO_SIZE_LIMIT} MB!`);
              continue;
            }
            if(!fileUtils._isExtensaoValida(anexo.extensao)) {
              errors.push(`Arquivo ${anexo.nome} tem uma extensão não permitida!`);
              continue;
            }
            novosAnexos.push(anexo);
          }
          if (errors.length > 0) {
            errors.forEach(e => this.callToast(e, toastTypeEnum.DANGER));
          }

          const anexosExistentes = Array.isArray(this.formData.anexos)? this.formData.anexos : []
          
          this.formData.anexos = [...anexosExistentes, ...novosAnexos];
          
          this.loadings.anexo = false;
          this.emitFormData();
          this.isDirty = true;
        },
        removerAnexo(index) {
          this.formData.anexos.splice(index, 1)
          this.emitFormData();
        },
        emitFormData(formData = this.formData) {
            this.$emit('update:form-data', formData)
        },
        async visualizarAnexo(anexo) {
          const fileUtils = await this.getFileUtils();
          fileUtils.visualizarArquivo(anexo.urlS3Visualizar);
        },
        async downloadAnexo(anexo) {
          const fileUtils = await this.getFileUtils();
          fileUtils.downloadArquivo(anexo.urlS3Download, anexo.nome);
        }
    }
  };
  </script>
  